export const en = {
    'new-package': 'New package'
};
